export default __webpack_public_path__ + "static/media/pageTemplates.6b9884c1.svg";